import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CityHero from '../../components/feature/CityHero';
import Services from '../home/components/Services';
import Testimonials from '../home/components/Testimonials';
import Contact from '../home/components/Contact';
import FAQ from '../home/components/FAQ';
import { useEffect } from 'react';

export default function ReparationFenetreVillefrancheSurSaone() {
  useEffect(() => {
    document.title = 'Villefranche-sur-Saône Réparation Fenêtres Fenêtres Lyon | Expert Fenêtres';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Villefranche-sur-Saône Réparation Fenêtres Fenêtres Lyon - Service professionnel de réparation de fenêtres à Villefranche-sur-Saône. Intervention rapide, devis gratuit. Spécialiste fenêtres PVC, alu, bois. Appelez-nous !');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'réparation fenêtres Villefranche-sur-Saône, dépannage fenêtres Villefranche-sur-Saône, vitrier Villefranche-sur-Saône');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <CityHero 
        cityName="Villefranche-sur-Saône"
        imageSeq="villefranche-sur-saone-hero-027"
      />
      <Services />
      <Testimonials />
      <Contact />
      <FAQ />
      <Footer />
    </div>
  );
}
